import { fromFileReturnMD5AndSize } from "./uploadUtil";
import type { MD5AndSize } from "./uploadUtil";

export type Md5Callback = (res: MD5AndSize | null, error: unknown) => void;

export type WorkerRequest = ["setFile", File];
export type WorkerReply = ["setRes", MD5AndSize] | ["setError", unknown] | ["setProgress", number];

export const fromFileReturnMD5AndSizeWorker = (
  file: File,
  callback: Md5Callback,
  onProgress?: (percent: number) => void,
): (() => void) => {
  const w = new Worker(new URL("./fromFileReturnMD5AndSize.worker.ts", import.meta.url), {
    type: "module",
  });

  let settled = false;
  const settle: Md5Callback = (res, error) => {
    if (settled) return;
    settled = true;
    w.terminate();
    callback(res, error);
  };

  w.onmessage = (e: MessageEvent<WorkerReply>) => {
    if (e.data[0] === "setRes") {
      settle(e.data[1], null);
    } else if (e.data[0] === "setError") {
      settle(null, e.data[1]);
    } else if (e.data[0] === "setProgress") {
      if (!settled) onProgress?.(e.data[1]);
    }
  };
  w.onerror = (e) => {
    console.warn("[md5Worker] worker failed, hashing on the main thread:", e.message);
    fromFileReturnMD5AndSize(file, onProgress)
      .then((res) => settle(res, null))
      .catch((err: unknown) => settle(null, err));
  };
  const req: WorkerRequest = ["setFile", file];
  w.postMessage(req);

  return () => {
    settled = true;
    w.terminate();
  };
};
